import type { WatermarkIdentity } from "./videoWatermarkTypes";

const DEFAULT_IDENTITY: WatermarkIdentity = {
  traceCode: '',
};

export function isoMinute(now = new Date()) {
  return now.toISOString().slice(0, 16).replace("T", " ");
}

export function marqueeText(identity: WatermarkIdentity, now = new Date()) {
  return `${identity.traceCode} · ${isoMinute(now)} UTC`;
}

export function buildIdentity(args: {
  traceCode?: string | null;
}): WatermarkIdentity {
  return { traceCode: args.traceCode ?? '' };
}

export { DEFAULT_IDENTITY };
